<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ? '中欧班列境外服务商':'Overseas service provider of China-Europe Railway Express'}}</div>
			<!-- 		<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				MG集团可提供中俄两国间的国际物流服务</div> -->
		</Header>

		<div class="TopTitle" data-aos="fade-up">
			<div class="">
				<!-- {{this.$route.name}} -->
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
				<!-- 中欧班列境外服务商 -->
			</div>
		</div>
		<div class="ContentText" data-aos="fade-down">
			<p>{{$store.state.navShow == true ? ' MG集团起源于俄罗斯圣彼得堡，在欧洲以及俄罗斯，中亚等地区建立了完善的自营服务网点和代理网络，以中欧班列境外(车板、铁路承运)业务优势与中国“—带—路”形成无缝衔接，主要提供往返于亚洲-欧洲的班列运输和综合物流服务，致力于为客户提供极具竞争力的综合物流解决物流方案。':'MG Group originated in St. Petersburg, Russia. As the carrier of the overseas section of the China-Europe freight train, MG Group has established an international transportation network and port agency points with the Eurasian railway and the CIS countries and regions based on the railways of Russia as the main country, providing European and American railways. A round-trip container shipping service. It has long-term cooperation with Russia and Eurasian national railways, transportation capacity and departure plan, and has self-operated resources in container transfer port reloading, car board resources, railway yards, automobile land transportation, customs clearance and distribution. The professional overseas operation team can integrate the advantageous railway resources of the countries in the overseas section, and provide customers with the most cost-effective and stable overseas section train transportation solutions.'}}
      </p>
			<div class="ContentImage">
				<img :src="$store.state.navShow == true ? imgList.topImg : imgList.topImgE">
			</div>
		</div>


		<div class="Contentbusiness">
			<div class="businessCon">
				<!-- <p class="tableTitleTitle">中欧班列境外服务商优势</p> -->
				<p class="tableTitleTitle">{{$store.state.navShow == true ?'中欧班列境外服务商':'Overseas service providers of China Railway Express'}}</p>
				<div class="ContentText" data-aos="fade-down">
					<p>{{$store.state.navShow == true ?'作为中欧班列境外服务商，MG集团有着丰富的班列操作经验，我们整合各个国家（白俄铁路，波兰铁路，俄罗斯铁路，哈萨克斯坦铁路，外蒙古铁路）最优势的一部分，从而能实现跨境运输高效对接，确保整体运输方案的安全、高效、可靠。我们能整合境外段国家的铁路优势资源为客户提供性价比最高和稳定的境外段班列运输解决方案。':'As an overseas service provider of China-Europe Railway, MG Group has rich experience in operating trains. We can take the most advantageous part of the country (Belarus Railway, Poland Railway, Russian Railway, Kazakhstan Railway, and Outer Mongolia Railway), so as to achieve Cross-border transport universities are connected to ensure the safety, efficiency and reliability of the overall transport scheme. We can integrate the advantageous railway resources of overseas countries to provide customers with the most cost-effective and stable overseas train transportation solutions.'}}</p>
				</div>

			</div>
		</div>

		<div class="ContenMapImg">
			<img :src="$store.state.navShow == true ? imgList.mapImg :imgList.mapImgE" data-aos="fade-down">
		</div>


		<div class="ContenImg">
			<img class="ContenImg01" :src="imgList.carImg" data-aos="fade-down">
			<div class="ContenImgBot">
				<img class="ContenImg02" :src="imgList.Container01Img" data-aos="fade-down">
				<img class="ContenImg03" :src="imgList.Container02Img" data-aos="fade-down">
			</div>
		</div>




		<div class="buttonImgSRR">
			<img :src="imgList.bottonImg">
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {

				imgList: {
					bannerImg: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/banner.jpg'),
					topImg: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/top.jpg'),
					topImgE: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/topE.jpg'),
					mapImg: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/map.jpg'),
					mapImgE: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/mapE.jpg'),

					carImg: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/car.jpg'),
					Container01Img: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/Container01.jpg'),
					Container02Img: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/Container02.jpg'),

					bottonImg: require('@/assets/chinaAndRussia/bottonImg.png'),
				},
			}
		},
		methods: {


		}
	}
</script>

<style lang="less">
	.chinaEuropeTrain {
		background-color: #FFF;
	}
	.ContenImg {
		img {
			vertical-align: bottom;
		}
		width: 92%;
		margin: 0 4%;
		margin-top: 2.5rem;
		margin-bottom: 1.25rem;
		.ContenImg01 {
			width: 100%;
			height: 12.25rem;
			margin-bottom: 1rem;
		}
		.ContenImgBot {
			display: flex;
			justify-content: space-between;
			align-items: center;
			&>img {
				width: 48%;
				height: 6.6875rem;
			}
			
		}
	}

	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 1.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}

		&>.ContentImage {
			width: 100%;
			height: 7.5rem;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}







	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 1rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 2.1875rem;
	}

	.tableTitlePText {
		font-size: 0.625rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}




	.Contentbusiness {
		width: 100%;

		.businessCon {
			width: 92%;
			margin: 0 4%;
			margin-top: 1.5rem;
			margin-bottom: 1rem;

		}
	}

	.ContenMapImg {
		width: 100%;
		height: 8.78125rem;
	}



	.buttonImgSRR {
		width: 100%;
		height: 4.9375rem;
		// height: 3.125rem;
		// margin-top: 0.78125rem;
	}
</style>
